export default __webpack_public_path__ + "static/media/TVSProductoDelMesFamilia.33af5712.webp";